import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CredentialsFactory } from 'authorization';
import { CouchDbRepository, RequestDataAccessServiceConfig } from 'data-access';
import { from, Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

export abstract class IBirthplaceDictionary {
  abstract searchByFullName(fullName: string, limit: number): Observable<string>;
  abstract searchByName(name: string, limit: number): Observable<string>;
}

@Injectable()
export class CouchDbViewBasedBirthplaceDictionary extends IBirthplaceDictionary {

  constructor(private _httpClient: HttpClient,
    private _config: RequestDataAccessServiceConfig,
    private _credentialsFactory: CredentialsFactory
  ) {
    super();
  }

  searchByFullName(fullName: string, limit: number): Observable<string> {
    return this.search(fullName, 'full_name_view', 'full_name_index', limit);
  }

  searchByName(name: string, limit: number): Observable<string> {
    throw new Error('Method not implemented.');
  }

  private search(text: string, viewName: string, indexName: string, limit: number): Observable<string> {
    const query = this._config.getServerURL()
      + 'kladr/_design/'
      + viewName
      + '/'
      + '_view'
      + '/'
      + indexName
      + '?limit=' + limit.toString()
      + '&startkey=' + '%22' + encodeURI(text) + '%22';

    return CouchDbRepository.authorizeExecute(this._credentialsFactory, (opt) => this._httpClient.get(query, opt).pipe(mergeMap((x: any) => from(x.rows as Array<string>)), map((x: any) => x.key)), true);
  }
}